<script>
    import { http } from '@/system/http.js';
    import Switchery from '@/system/components/global/form/Switchery';
    import CustomClientFieldsContainer from '@/system/components/apps/custom_client_fields/CustomClientFieldsContainer';
    import PhoneNumberInput from '@/system/components/global/form/PhoneNumberInput';
    import DatePicker from '@/system/components/global/form/DatePicker.vue';
    import ClientForm from '@/online_booking/new/components/common_booking/ClientForm.vue';
    import StepCounter from '@/online_booking/new/components/common/StepCounter';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import Card from '@/online_booking/new/components/common/Card';
    import PreviousButton from '@/online_booking/new/components/common/PreviousButton';
    import EpButton from '@/system/components/global/button';
    import { appendCustomAttributesToFormData } from '@/system/helpers';
    import { bookingKeys } from '@/online_booking/new/helpers/constants';

    export default {

        data() {
            return {
                loading: false,
                logged_in_client: false,
                online_booking_settings: null,
                user: {},
                event: null,
                event_group: null,
                slug: null,
                is_giftcards_active: false,
                giftcard_code : '',
                custom_client_fields: [],
                custom_attributes: {},
                chosen_voucher : null,
                applicable_vouchers : [],
                discount_code: '',
                is_discount_codes_active: false,
                event_settings_fields: {},
                form: {
                    name: '',
                    email: '',
                    phone: '',
                    address: '',
                    address_line_2: '',
                    zip: '',
                    city: '',
                    zone: '',
                    country: '',
                    notes: '',
                    danmark: 0,
                    dob: '',
                }
            }
        },

        methods: {
            ...mapActions('OnlineBooking', ['setCurrentStep', 'setSelectedValue']),

            infoEventAdded() {

                this.errors.clear();
                this.loading = true;
                const dataFrm = new FormData($('#fill-info-frm')[0]);

                Object.keys(this.form).forEach((property) => {
                    dataFrm.append(property, this.form[property])
                })

                appendCustomAttributesToFormData(dataFrm, this.custom_attributes);

                http.post('/event/' + this.slug + '/is-choose-client', dataFrm)
                    .then(({data}) => {
                        var confirmInfo = null;
                        if (this.logged_in_client) {
                            confirmInfo = {
                                name: this.logged_in_client.name,
                                email: this.logged_in_client.email,
                                phone: this.logged_in_client.phone,
                                address: this.logged_in_client.address,
                                address_line_2: this.logged_in_client.address_line_2,
                                zip: this.logged_in_client.zip,
                                city: this.logged_in_client.city,
                                zone: this.logged_in_client.zone,
                                country: this.logged_in_client.country,
                                notes: this.form.notes,
                                danmark: this.form.danmark,
                            };
                        }
                        else {
                            confirmInfo = Object.assign({}, this.form)
                        }

                        if (data.giftcard) {
                            this.$store.commit('setGiftcard', data.giftcard);
                        }

                        if (data.discount_code) {
                            this.$store.commit('setDiscountCode', data.discount_code);
                        }

                        if (data.used_voucher) {
                            this.$store.commit('setUsedVoucher', data.used_voucher);
                        }
                        else {
                            this.$store.commit('removeUsedVoucher');
                        }

                        if (data.choose_client) {
                            this.$event_bus.$emit('chooseEventUser', {dataFrm: dataFrm, clients: data.markup.clients, confirmInfo: confirmInfo});
                        } else {
                            dataFrm.append('client', data.client);
                            this.$event_bus.$emit('confirmEvent', {dataFrm: dataFrm, confirmInfo: confirmInfo});
                        }

                        this.loading = false;
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                        if (errorBag) {
                            this.$setErrorBag(errorBag);
                            if (errorBag.items && errorBag.items.length > 0) {
                                let fieldName = errorBag.items[0].field.split('.').pop();
                                $('[name=' + fieldName + ']').focus();
                            }
                        }
                    });
            }
        },

        mounted() {
            this.setCurrentStep('fillInformation');

            this.$event_bus.$on('LoadEventData', (data) => {
                this.user = data.user;
                this.event = data.event;
                this.event_group = data.event_group;
                this.slug = data.event.slug;
                this.logged_in_client = data.logged_in_client;
                this.is_giftcards_active = data.is_giftcards_active;
                this.$store.commit('removeGiftcard');
                this.$store.commit('removeDiscountCode');
                this.$store.commit('removeUsedVoucher');
                this.online_booking_settings = data.online_booking_settings;
                this.applicable_vouchers = data.applicable_vouchers;
                this.is_discount_codes_active = data.is_discount_codes_active;
                this.event_settings_fields = data.event_setting_fields;

                if (data.applicable_vouchers[0]) {
                    this.chosen_voucher = data.applicable_vouchers[0].id;
                }

                this.custom_client_fields = data.custom_client_fields;
                this.setSelectedValue({
                    key: bookingKeys.FILL_INFORMATION,
                    value: data.logged_in_client ? data.logged_in_client.name : ''
                });
            });

            $.fn.modal.Constructor.prototype.enforceFocus = function() {};
        },

        watch: {
            chosen_voucher(newVal) {
                if (newVal) {
                    this.giftcard_code = '';
                }
            },

            isFillInformationStepActive (newVal) {
                if (newVal) {
                    this.$store.commit('removeGiftcard');
                    this.$store.commit('removeDiscountCode');
                    this.$store.commit('removeUsedVoucher');
                    this.$event_bus.$emit('FillEventInfoShowed');
                }
            },

            'form.name' (newValue) {
                // to make sure sidebar has the details of the client if they are NOT logged in
                this.setSelectedValue({
                    key: bookingKeys.FILL_INFORMATION,
                    value: newValue ? newValue : ''
                });
            },
        },

        computed: {
            ...mapState('OnlineBooking', ['currentStep']),
            ...mapGetters('OnlineBooking', ['currentStepNumber', 'totalStepCount', 'getPreviousStepId']),
            eventName() {
                return this.event_group ? this.event_group.name : this.event.name;
            },

            showDanmarkGroups() {
                return this.user.is_sygeforsikring_danmark_connected
                    && this.event_settings_fields
                    && ('danmark' in this.event_settings_fields && this.event_settings_fields.danmark != 0);
            },

            showSocialSecurity() {
                let showField = Boolean(this.showDanmarkGroups || this.event_settings_fields.cpr);

                if (this.logged_in_client && showField) {
                    return this.logged_in_client.cpr === '';
                }

                return showField;
            },

            showDateOfBirth() {
                return (this.logged_in_client && this.event_settings_fields.dob_required && !this.logged_in_client.dob) || (!this.logged_in_client && this.event_settings_fields.dob);
            },

            showCustomFields() {
                if (this.logged_in_client && this.logged_in_client.custom_attributes) {
                    return this.custom_client_fields.some(field => {
                        return field.required_in_event_booking && !this.logged_in_client.custom_attributes[field.identifier];
                    })
                }

                return this.custom_client_fields && this.custom_client_fields.length > 0;
            },

            show_waiting_list() {
              return this.event.is_filled && this.event.can_clients_singnup_for_waiting_list;
            },

            isFillInformationStepActive () {
                return this.currentStep === 'fillInformation';
            }
        },

        components: {
            PreviousButton,
            Card,
            DatePicker,
            ClientForm,
            Switchery,
            CustomClientFieldsContainer,
            PhoneNumberInput,
            StepCounter,
            EpButton,
        },
    };

</script>


<template>
    <div v-if="isFillInformationStepActive">
        <!-- Card Starts -->
        <card class="p-0 rounded-lg" id="information-panel-event">
            <!-- Main Section Title -->
            <h4 class="section-title">
                <step-counter :current="currentStepNumber" :total="totalStepCount" />
                {{ trans('online_booking.sidebar.your_details') }}
            </h4>

            <form
                id="fill-info-frm"
                role="form"
                @submit.prevent="infoEventAdded()"
            >
                <!-- Main Content -->
                <div v-if="event">
                    <div
                        id="collapseFillEventInfo"
                        class="panel-collapse collapse in"
                        role="tabpanel"
                        aria-labelledby="headingFillEventInfo"
                        data-parent="#event-accordion"
                    >
                        <div class="panel-body pb-0">
                            <div class="row">
                                <div class="col-xs-12">
                                    <ep-banner variant="warning" v-if="show_waiting_list">
                                        <span>{{ trans('waiting_list.event_alert') }}</span>
                                    </ep-banner>

                                    <client-form
                                        class="online-booking-client-form"
                                        v-if="!logged_in_client && event_settings_fields"
                                        v-model="form"
                                        :nameOptions="{ display: true, required: true }"
                                        :emailOptions="{ display: true, required: true}"
                                        :phoneOptions="{ display: event_settings_fields.phone, required: event_settings_fields.phone_required, dropdownParent: '#fill-info-frm' }"
                                        :addressOptions="{ display: event_settings_fields.address, required: event_settings_fields.address_required, countrySelectParent: 'fill-info-frm' }"
                                        :cprOptions="{ display: showSocialSecurity, required: Boolean(event_settings_fields && event_settings_fields.cpr_required) }"
                                        :dobOptions="{ display: showDateOfBirth, required: Boolean(event_settings_fields && event_settings_fields.dob_required)}"
                                        :validationErrors="errors"
                                        show-required-indicator
                                    >
                                    </client-form>

                                    <!-- Alert - Already logged in -->
                                    <ep-banner class="mb-6" v-if="logged_in_client">
                                        <i class="zmdi zmdi-info-outline m-r-10 alert-ico"></i>
                                        <span>{{ trans('online_booking.logged_in_as') }}</span>&nbsp;<strong>{{ logged_in_client.name }}</strong>
                                    </ep-banner>

                                    <div class="form-group" v-if="applicable_vouchers.length && logged_in_client && !show_waiting_list">
                                        <label class="control-label" for="user-notes">
                                            {{ trans('global.voucher') }}
                                        </label>
                                        <div>
                                            <select class="form-control" name="voucher" v-model="chosen_voucher">
                                                <option :value="voucher.id" v-for="voucher in applicable_vouchers" :key="voucher.id">{{ voucher.name }} ({{ trans('online_booking.clips_left', {clips_left: voucher.clips_left, clips: voucher.clips}) }})</option>
                                                <option value="">{{ trans('vouchers.subscribe_vouchers_dont_use') }}</option>
                                            </select>
                                            <small class="text-muted">{{ trans('vouchers.subscribe_text') }}</small>
                                        </div>
                                    </div>

                                    <!-- End of Alert -->

                                    <template v-if="showCustomFields">
                                        <custom-client-fields-container context="events" :custom-fields="custom_client_fields" :validation-errors="errors" errors-prefix="custom_attributes" v-model="custom_attributes"></custom-client-fields-container>
                                    </template>

                                    <div
                                        class="form-group"
                                        :class="{ 'has-error' : errors.has('discount_code') }"
                                        v-if="is_discount_codes_active && !show_waiting_list"
                                    >
                                        <label class="control-label" for="user-notes">
                                            {{ trans('global.discount') }}
                                        </label>
                                        <div>
                                            <div class="input-group">
                                                <div class="input-group-addon">
                                                    <i class="fa fa-tag m-r-5"></i>
                                                    {{ trans('discount_codes.discount_code') }}
                                                </div>

                                                <input
                                                    class="form-control"
                                                    type="text"
                                                    name="discount_code"
                                                    v-model="discount_code"
                                                    autocomplete="off"
                                                />
                                            </div>
                                            <span class="help-block m-b-0" v-if="errors.has('discount_code')">
                                                {{ errors.first('discount_code') }}
                                            </span>
                                            <small v-else class="text-muted">{{ trans('discount_codes.input_description') }}</small>
                                        </div>
                                    </div>

                                    <div class="form-group" :class="{ 'has-error' : errors.has('giftcard_code') }" v-if="is_giftcards_active && user.giftcards_settings.enabled_events && !show_waiting_list" v-show="!chosen_voucher">
                                        <label class="control-label" for="user-notes">
                                            {{ trans('giftcards.title') }}
                                        </label>
                                        <div>
                                            <div class="input-group">
                                                <div class="input-group-addon">
                                                    <i class="zmdi zmdi-card-giftcard m-r-5"></i>{{ trans('giftcards.giftcard_code') }}
                                                </div>

                                                <input id="giftcardinput" class="form-control" type="text" name="giftcard_code" v-model="giftcard_code" autocomplete="off">
                                            </div>
                                            <small class="text-muted">{{ trans('giftcards.input_description') }}</small>
                                            <span v-if="errors.has('giftcard_code')" class="m-0 help-block">{{ errors.first('giftcard_code') }}</span>
                                        </div>
                                    </div>

                                    <div v-if="event_settings_fields.notes || show_waiting_list" class="form-group" :class="{ 'has-error' : errors.has('notes') }">
                                        <label class="control-label" for="user-notes">
                                            {{ trans('online_booking.fill_notes') }}  <span class="text-danger" v-show="!show_waiting_list && event_settings_fields.notes_required">*</span>
                                        </label>
                                        <div>
                                            <textarea class="form-control" rows="4" id="user-notes" v-model="form.notes" :required="!show_waiting_list && event_settings_fields.notes_required"></textarea>
                                            <span v-if="errors.has('notes')" class="help-block m-b-0">{{ errors.first('notes') }}</span>
                                        </div>
                                    </div>

                                    <div class="form-group" :class="{ 'has-error' : errors.has('cpr') }" v-if="logged_in_client && showSocialSecurity">
                                        <label class="control-label" >
                                            {{ trans('clients.social_security') }}  <span class="text-danger" v-show="Boolean(event_settings_fields && event_settings_fields.cpr_required)">*</span>
                                        </label>

                                        <div>
                                            <input class="form-control" type="text" name="cpr" autocomplete="off" :required="Boolean(event_settings_fields && event_settings_fields.cpr_required)">
                                            <span v-if="errors.has('cpr')" class="help-block m-b-0">
                                                {{ errors.first('cpr') }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="form-group" :class="{ 'has-error' : errors.has('dob') }" v-if="logged_in_client && showDateOfBirth">
                                        <label class="control-label" >
                                            {{ trans('client.date_of_birth') }}  <span class="text-danger" v-show="Boolean(event_settings_fields && event_settings_fields.dob_required)">*</span>
                                        </label>

                                        <div>
                                            <date-picker id="dob" name="dob" v-model="form.dob" :isRequired="Boolean(event_settings_fields && event_settings_fields.dob_required)" :clearable="true"></date-picker>
                                            <span v-if="errors.has('dob')" class="help-block m-b-0">
                                                {{ errors.first('dob') }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="form-group" v-if="showDanmarkGroups">
                                        <label class="control-label" for="user-address"></label>
                                        <div>
                                            <switchery text='Er du medlem af Sygeforsikringen "danmark"?' :name="'danmark'" class="m-l-5" v-model.number="form.danmark" :light="true" active-color="var(--brand-primary)"></switchery>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Button right inside where the card ends -->
                <div class="flex justify-between flex-wrap p-6 pt-0" v-if="event">
                    <previous-button :previous-step-id="getPreviousStepId" />
                    <ep-button
                        :loading="loading"
                        :disabled="loading"
                        type="submit"
                    >
                        <span class="hidden sm:inline" v-if="show_waiting_list">{{ trans('waiting_list.event_join') }}</span>
                        <span class="hidden sm:inline" v-else>{{ trans('online_booking.continue_to_confirmation') }}</span>
                        <span class="sm:hidden">{{ trans('global.continue') }}</span>
                        <i class="zmdi zmdi-arrow-right ml-3"></i>
                    </ep-button>
                </div>
            </form>
        </card>
    </div>
</template>
